export const reservationPlaceholderKeys = [
  'resource-url',
  'start-date',
  'end-date',
  'start-time',
  'end-time',
  'resource-capacity',
  'attendees-count',
  'resource-display-name',
  'resource-type',
] as const;

export type ReservationPlaceholderKey = (typeof reservationPlaceholderKeys)[number];

export type ReservationPlaceholderValues = Partial<
  Record<ReservationPlaceholderKey, string | number | null | undefined>
>;

export function replaceReservationPlaceholders(
  template: string | null | undefined,
  values: ReservationPlaceholderValues
): string {
  let result = template ?? '';

  for (const key of reservationPlaceholderKeys) {
    const value = values[key];
    result = result.split(`{${key}}`).join(value == null ? '' : String(value));
  }

  return result;
}
